function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "visa-color");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Cards",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Payment-Methods",
  transform: "translate(-64.000000, -192.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "visa-color",
  transform: "translate(64.000000, 192.000000)"
}, React.createElement("rect", {
  id: "card_bg",
  fill: "#2A2A6C",
  x: 0,
  y: 0,
  width: 24,
  height: 16,
  rx: 2
}), React.createElement("path", {
  d: "M11.93,5.69 L10.93,10.32 L9.74,10.32 L10.74,5.69 L11.93,5.69 Z M16.93,8.69 L17.56,6.95 L18,8.68 L16.93,8.69 Z M18.27,10.33 L19.37,10.33 L18.37,5.69999745 L17.37,5.69999745 C17.1467508,5.6993228 16.94524,5.83366335 16.86,6.04 L15.06,10.33 L16.32,10.33 L16.57,9.64 L18.1,9.64 L18.27,10.33 Z M15.17,8.81 C15.17,7.59 13.49,7.52 13.5,6.98 C13.5,6.81 13.66,6.63 14,6.59 C14.4040733,6.55184506 14.811067,6.62082706 15.18,6.79 L15.39,5.79 C15.0345384,5.65895054 14.6588473,5.59125845 14.28,5.59 C13.09,5.59 12.28,6.22 12.28,7.12 C12.28,7.78 12.88,8.12 13.33,8.38 C13.78,8.64 13.95,8.75 13.95,8.95 C13.95,9.15 13.58,9.4 13.24,9.4 C12.8102452,9.4190676 12.382921,9.3260212 12,9.13 L11.78,10.13 C12.2065117,10.2848576 12.6562631,10.3660157 13.11,10.37 C14.37,10.37 15.19,9.75 15.19,8.79 M10.22,5.69 L8.28,10.32 L7,10.32 L6,6.63 C5.98040934,6.45536542 5.87553273,6.30179609 5.72,6.22 C5.36256268,6.04819382 4.98684183,5.91736245 4.6,5.83 L4.6,5.69 L6.6,5.69 C6.87675825,5.69210471 7.11046997,5.89607129 7.15,6.17 L7.66,8.84 L9,5.69 L10.22,5.69 Z",
  id: "visa-logo",
  fill: "#FFFFFF"
}))));

var SvgVisa = function SvgVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visa.f2f6fa78.svg";
export { ForwardRef as ReactComponent };